var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFace1Left(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1005.32 926",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-face-1 {\n        fill: #f88459;\n      }\n\n      .cls-face-2 {\n        fill: #d79db6;\n      }\n\n      .cls-face-3 {\n        fill: #fabdc6;\n      }\n\n      .cls-face-4 {\n        fill: #fff;\n      }\n\n      .cls-skin-color {\n        fill: var(--custom-skin-color, #dd8f5f) !important;\n      }\n\n      .cls-face-6 {\n        fill: #42210b;\n      }\n\n      .cls-face-7 {\n        fill: #f44d41;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-skin-color",
    d: "M528.23,0h0C791.54,0,1005.32,213.78,1005.32,477.09v104.95c0,189.84-154.12,343.96-343.96,343.96h-266.26c-189.84,0-343.96-154.12-343.96-343.96v-104.95C51.13,213.78,264.91,0,528.23,0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-face-4",
    cx: 329.95,
    cy: 463,
    r: 114.74
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-face-6",
    d: "M329.95,583.68c-66.54,0-120.68-54.14-120.68-120.68s54.14-120.68,120.68-120.68,120.68,54.14,120.68,120.68-54.14,120.68-120.68,120.68ZM329.95,354.2c-60,0-108.8,48.81-108.8,108.8s48.81,108.8,108.8,108.8,108.8-48.81,108.8-108.8-48.81-108.8-108.8-108.8Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-face-6",
    cx: 293.54,
    cy: 460.99,
    r: 72.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-face-6",
    d: "M293.54,539.5c-43.29,0-78.51-35.22-78.51-78.51s35.22-78.51,78.51-78.51,78.51,35.22,78.51,78.51-35.22,78.51-78.51,78.51ZM293.54,394.56c-36.63,0-66.43,29.8-66.43,66.43s29.8,66.43,66.43,66.43,66.43-29.8,66.43-66.43-29.8-66.43-66.43-66.43Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-face-2",
    d: "M329.95,342.22c66.6,0,120.78,54.18,120.78,120.78,0,9.57-1.15,18.87-3.27,27.8l-224.45-83.86c20.23-38.44,60.56-64.72,106.93-64.72Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-face-1",
    points: "55.01 475.08 0 647.52 110.01 647.52 55.01 475.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-face-7",
    points: "55.9 477.88 55.9 647.52 110.01 647.52 55.9 477.88"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-face-6",
    d: "M236.28,739.12c-12.74,10.1-25.67,15.75-38.53,16.83-12.7,1.05-31.9-1.4-57.08-7.32l-1.82-.44c-5.79-1.38-12.99-3.1-22.9-3.64-.67-.04-1.34,0-2.01-.03-1.48-.06-2.96-.06-4.44-.06-1.48,0-2.96,0-4.44.06-.67.03-1.34,0-2.01.03-3.92.21-7.41.61-10.57,1.1,4,7.37,8.25,14.59,12.76,21.62.28-.01.56-.04.85-.05,1.14-.04,2.27-.05,3.41-.04,1.14,0,2.28,0,3.41.04,4.62.19,9.25.7,13.87,1.58.29.06.59.12.88.18,2.37.47,4.73,1.01,7.09,1.67l.02-.06.7.17c9.1,2.14,34.68,8.16,56.21,8.16,2.74,0,5.41-.1,7.98-.31,17.31-1.45,34.24-8.65,50.45-21.43,5.26-4.15,5.91-11.9,1.32-16.78-3.98-4.23-10.59-4.88-15.14-1.28Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-face-3",
    cx: 407.41,
    cy: 662.15,
    rx: 70.6,
    ry: 35.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-skin-color",
    cx: 730.97,
    cy: 586.58,
    r: 120.78
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFace1Left);
export default __webpack_public_path__ + "static/media/face1-left.5fa9704ead14790fb93ec87a3a6d4382.svg";
export { ForwardRef as ReactComponent };